export default __webpack_public_path__ + "static/media/My-Benefits-not.d60a745f.svg";